import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { ConvertNumService } from "@/assets/js/convertNumberService.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import { updatePageSeo } from "@/utils/seo";
const convertNumberService = new ConvertNumService();

export default {
    name: "jobListingIndex",
    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            jobList: {},
            isLoading: true,
            category_count: "",
            categoryInfo: {},
            jobTypeList: {
                job_type: ""
            },
            isCategoryDropdownOpen: false,
            isJobTypeDropdownOpen: false,
            isRegionDropdownOpen: false,
            isSearched: false,
            regionArr: RegionJson,
            category: [],
            keyword: {
                job_title: "",
                job_type: "",
                category_name: "",
                region: ""
            },
            page_status: false,
            job_count: ""
        }
    },

    computed: {
        selectedCategoryName() {
            if (!this.category || !Array.isArray(this.category)) return '';
            const selected = this.category.find(cat => cat.id == this.keyword.category_name);
            return selected ? selected.category_name : '';
        },

        currentCategoryTitle() {
            if (this.selectedCategoryName) {
                return this.selectedCategoryName;
            }
            if (this.categoryInfo && this.categoryInfo.category_name) {
                return this.categoryInfo.category_name;
            }
            return '';
        },

        displayCategoryTitle() {
            if (this.selectedCategoryName) {
                return this.selectedCategoryName;
            }
            if (this.categoryInfo && this.categoryInfo.category_name) {
                return this.categoryInfo.category_name;
            }
            return 'အလုပ်အမျိုးအစားများကို ရှာဖွေစစ်ထုတ်ရန်';
        },

        selectedJobTypeName() {
            const types = {
                '1': 'Full-time',
                '2': 'Part-time',
                '3': 'Internship',
                '4': 'Freelance',
                '5': 'Remote Job',
            };
            return types[this.keyword.job_type] || '';
        },

        selectedRegionName() {
            if (this.keyword.region === '' || this.keyword.region === null || this.keyword.region === undefined) {
                return '';
            }
            return this.regionArr[this.keyword.region] || '';
        },

        activeFiltersList() {
            const list = [];
            if (this.keyword.job_title) {
                list.push({ type: 'job_title', label: `"${this.keyword.job_title}"` });
            }
            if (this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined && this.selectedRegionName) {
                list.push({ type: 'region', label: `"${this.selectedRegionName}"` });
            }
            if (this.keyword.job_type && this.selectedJobTypeName) {
                list.push({ type: 'job_type', label: `"${this.selectedJobTypeName}"` });
            }
            return list;
        },

        displayedJobs() {
            if (this.jobList && Array.isArray(this.jobList.data)) {
                return this.jobList.data;
            }
            return Array.isArray(this.jobList) ? this.jobList : [];
        },

        jobCountDisplay() {
            if (this.job_count) {
                return this.job_count;
            }
            const count = this.jobList && this.jobList.total ? this.jobList.total : (Array.isArray(this.displayedJobs) ? this.displayedJobs.length : 0);
            return convertNumberService.convertEng2Mm(count.toString());
        },

        total() {
            return this.job_count;
        }
    },

    methods: {
        getJobInfo(page = 1) {
            this.isLoading = true;
            axios.get("/job/info/" + this.$route.params.id + "?page=" + page)
                .then(response => {
                    this.jobList = response.data || {};
                    this.job_count = this.jobList.total ? convertNumberService.convertEng2Mm(this.jobList.total.toString()) : convertNumberService.convertEng2Mm("0");
                })
                .catch(() => {
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getJobTypeInfo(catId) {
            const id = catId !== undefined ? catId : (this.keyword.category_name || this.$route.params.id);
            if (!id || id == 0) {
                this.jobTypeList = [];
                this.categoryInfo = {};
                updatePageSeo({
                    title: 'အလုပ်အကိုင်များ ရှာဖွေလျှောက်ထားရန် - Jobs in Myanmar',
                    description: 'မြန်မာနိုင်ငံရှိ အကောင်းဆုံး အလုပ်အကိုင်အခွင့်အလမ်းများကို ရှာဖွေလျှောက်ထားလိုက်ပါ။'
                });
                return;
            }
            axios.get("/job/type/info/" + id)
                .then(response => {
                    this.jobTypeList = response.data ? response.data.job_type || [] : [];
                    this.categoryInfo = response.data ? response.data.category || {} : {};
                    if (this.categoryInfo && this.categoryInfo.category_name) {
                        updatePageSeo({
                            title: `${this.categoryInfo.category_name} အလုပ်အကိုင်များ`,
                            description: `မြန်မာနိုင်ငံရှိ ${this.categoryInfo.category_name} အလုပ်အကိုင်အခွင့်အလမ်းများကို ရှာဖွေလျှောက်ထားလိုက်ပါ။`
                        });
                    }
                })
                .catch(() => {
                    this.jobTypeList = [];
                    this.categoryInfo = {};
                });
        },
        searchJob(page = 1) {
            const hasRegion = this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined;
            var request = {
                params: {
                    keyword: this.keyword.job_title,
                    keyword1: this.keyword.category_name,
                    keyword2: hasRegion ? this.keyword.region : '',
                    keyword3: this.keyword.job_type
                }
            };
            this.isLoading = true;
            axios.get("/applicant/search/jobresult?page=" + page, request)
                .then(response => {
                    this.isSearched = true;
                    this.page_status = true;
                    this.jobList = response.data || {};
                    this.job_count = this.jobList.total ? convertNumberService.convertEng2Mm(this.jobList.total.toString()) : convertNumberService.convertEng2Mm("0");
                    this.getJobTypeInfo(this.keyword.category_name);
                })
                .catch(() => {
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        clearSearch() {
            this.keyword.job_title = '';
            this.keyword.category_name = Number(this.$route.params.id) || this.$route.params.id || '';
            this.keyword.region = '';
            this.keyword.job_type = '';
            this.isSearched = false;
            this.page_status = false;
            this.getJobInfo(1);
            this.getJobTypeInfo(this.keyword.category_name);
        },

        filterByJobType(type) {
            if (this.keyword.job_type == type) {
                this.keyword.job_type = '';
            } else {
                this.keyword.job_type = type;
            }
            this.searchJob(1);
        },
        getCategory() {
            axios.get("/job/category/list?has_jobs=true")
                .then(response => {
                    this.category = response.data;
                })
                .catch(() => {
                });
        },

        getJobType(job_type) {
            if (job_type == '1') {
                this.job_type = 'Full-time';
            } else if (job_type == '2') {
                this.job_type = 'Part-time';
            } else if (job_type == '3') {
                this.job_type = 'Internship';
            } else if (job_type == '4') {
                this.job_type = 'Freelance';
            } else if (job_type == '5') {
                this.job_type = 'Remote Job';
            } else {
                this.job_type = 'သတ်မှတ်ထားခြင်းမရှိပါ';
            }
            return this.job_type;
        },

        getJobTypeShort(job_type) {
            if (job_type == '1') {
                this.job_type = 'Full-time';
            } else if (job_type == '2') {
                this.job_type = 'Part-time';
            } else if (job_type == '3') {
                this.job_type = 'Internship';
            } else if (job_type == '4') {
                this.job_type = 'Freelance';
            } else if (job_type == '5') {
                this.job_type = 'Remote Job';
            } else {
                this.job_type = 'သတ်မှတ်ထားခြင်းမရှိပါ';
            }
            return this.job_type;
        },


        convertEng2Mm(number) {
            if (number === undefined || number === null) {
                return '';
            }
            this.mm_count = convertNumberService.convertEng2Mm(number.toString());
            return this.mm_count;
        },

        toggleCategoryDropdown() {
            this.isCategoryDropdownOpen = !this.isCategoryDropdownOpen;
            this.isJobTypeDropdownOpen = false;
            this.isRegionDropdownOpen = false;
        },

        selectCategory(id) {
            this.keyword.category_name = id;
            this.isCategoryDropdownOpen = false;
            this.getJobTypeInfo(id);
        },

        toggleJobTypeDropdown() {
            this.isJobTypeDropdownOpen = !this.isJobTypeDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isRegionDropdownOpen = false;
        },

        selectJobType(id) {
            this.keyword.job_type = id;
            this.isJobTypeDropdownOpen = false;
        },

        toggleRegionDropdown() {
            this.isRegionDropdownOpen = !this.isRegionDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectRegion(id) {
            this.keyword.region = id;
            this.isRegionDropdownOpen = false;
        },

        handleOutsideClick(e) {
            if (!e.target.closest('.custom-select-wrapper')) {
                this.isCategoryDropdownOpen = false;
                this.isJobTypeDropdownOpen = false;
                this.isRegionDropdownOpen = false;
            }
        },

        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    },

    mounted() {
        this.keyword.category_name = Number(this.$route.params.id) || this.$route.params.id || "";
        this.getJobInfo();
        this.getJobTypeInfo();
        this.getCategory();
        window.addEventListener('click', this.handleOutsideClick);
    },

    beforeDestroy() {
        window.removeEventListener('click', this.handleOutsideClick);
    }
};
